import SEO from "@/components/SEO";
import Hero from "@/components/sections/Hero";
import BenefitsBar from "@/components/sections/BenefitsBar";
import Marquee from "@/components/Marquee";
import About from "@/components/sections/About";
import ServicesGrid from "@/components/sections/ServicesGrid";
import Gallery from "@/components/sections/Gallery";
import Differentials from "@/components/sections/Differentials";
import Testimonials from "@/components/sections/Testimonials";
import Regions from "@/components/sections/Regions";
import QuoteSection from "@/components/sections/QuoteSection";
import FinalCTA from "@/components/sections/FinalCTA";
import FaqSection from "@/components/sections/FaqSection";
import { FAQ } from "@/data/site";
import { faqSchema, breadcrumbSchema } from "@/lib/schema";

const MARQUEE = [
  "Guincho Leve", "Guincho Pesado", "Auto Socorro 24h", "Transporte de Máquinas",
  "Assistência Rodoviária", "Reboque de Caminhões", "Seguradoras",
];

export default function Home() {
  return (
    <>
      <SEO
        title="Auto Socorro Pimenta | Guincho 24 Horas em Rondônia e Mato Grosso | Guincho Leve, Pesado e Munck"
        description="Há mais de 20 anos oferecendo guincho leve e pesado, transporte de máquinas, assistência rodoviária e auto socorro 24 horas em Rondônia e Mato Grosso. Atendimento rápido, seguro e especializado."
        path="/"
        schemas={[faqSchema(FAQ), breadcrumbSchema([{ name: "Início", path: "/" }])]}
      />
      <Hero />
      <BenefitsBar />
      <Marquee items={MARQUEE} />
      <About />
      <ServicesGrid />
      <Gallery />
      <Differentials />
      <Testimonials />
      <Regions />
      <QuoteSection />
      <FinalCTA />
      <FaqSection />
    </>
  );
}
